<template>
  <div class="grid">
    <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />
        <!-- <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2"> -->
          <div class="grid p-fluid mt-3" style="margin-top: 2%;">

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <InputText v-model="vehicle_no"> </InputText>
                <label>Vehicle No</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar v-model="event_from_date" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false"
                  hourFormat="12" />
                <label>From Date</label>
              </span>
            </div>

            <div class="field col-12 md:col-2">
              <span class="p-float-label">
                <Calendar v-model="event_to_date" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false"
                  hourFormat="12" />
                <label>To Date</label>
              </span>
            </div>
            <!-- <div class="my-2">
                <span class="p-float-label">
                  <Dropdown
                      id="status"
                      v-model="event_status"
                      :options="dropdownItems"
                      :value="dropdownItems.value"
                      optionLabel="name"
                      style="width: 150px;"
                    ></Dropdown>
                  <label>Status</label>
                  </span>
              </div>&nbsp; -->
              <div class="field col-12 md:col-2">
                <Button icon="pi pi-search" v-tooltip.bottom="'Search'" @click="search(1)" />&nbsp; &nbsp;
                <Button icon="pi pi-upload" v-tooltip.bottom="'export'" @click="exportCSV" />
              </div>
          </div>
          <!-- </template>
          <template v-slot:end> -->
            <!-- <json-excel :data="product"> -->
            <!-- </json-excel> -->
          <!-- </template>
        </Toolbar> -->
        
        <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
          :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit" :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
          style="font-size: 12px" :rowHover="true" showGridlines>
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0"><b> Outward Garbage Entry</b></h5>
             
              <div>
                <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Refresh'" />
                &nbsp;
                <Button icon="pi pi-plus" v-tooltip.bottom="'Add'" @click="openNew" />
              </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total :</span>{{ totalRecords }}
            </div>
          </template>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Vehicle No." :field="columns[1]" style="min-width: 10rem">
            <template #body="{ data }">
              {{ data.vehicle_no }}
            </template>
          </Column>
          <Column header="Date" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.date_time)}} {{date_time(data.date_time)}}
            </template>
          </Column>
          
          <Column header="Action" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" title="Edit Route" v-tooltip.bottom="'Edit'"
                class="p-button-rounded p-button-help mr-2" @click="editProduct(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
        <Dialog header="Update In Entry" v-model:visible="edit_productDialog" :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }" :modal="true">
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="vehicle_no" type="text" v-model.trim="product.vehicle_no" required="true" autofocus
                      :class="{ 'p-invalid': submitted && !product.vehicle_no }" />
                    <label for="vehicle_no">Vehicle Number</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="dry_waste" type="text" v-model.trim="product.dry_waste" required="true" autofocus
                      :class="{ 'p-invalid': submitted && !product.dry_waste }" />
                    <label>Dry Waste (Kg)</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="wet_waste" type="text" v-model.trim="product.wet_waste" required="true" autofocus
                      :class="{ 'p-invalid': submitted && !product.wet_waste }" />
                    <label>Wet Waste (Kg)</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <Calendar v-model="out_date" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false"
                      hourFormat="12" />
                    <label>Date</label>
                  </span>
                </div>
                <div class="field col-12 md:col-6" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <Calendar id="calendar-timeonly" v-model="out_time" timeOnly hourFormat="12" />
                    <label>Out Time</label>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template #footer>
            <Button label="Update" @click="add_inward" icon="pi pi-check" class="p-button-warning" />
          </template>
        </Dialog>

        <Dialog header="Add Outward Entry" v-model:visible="add_productDialog" :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '20vw' }" :modal="true">
          <div class="card">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12" style="margin-top: 1%;">
              <span class="p-float-label">
                <Dropdown
                      id="status"
                      v-model="waste_type_dropdownItem"
                      :options="waste_type_dropdownItems"
                      :value="waste_type_dropdownItems._id"
                      optionLabel="name"
                    ></Dropdown>
              <label for="vehicle_no">Material Type</label>
              </span>
            </div>
            <div class="field col-12 md:col-12" style="margin-top: 1%;">
              <span class="p-float-label">
              <InputText id="weight" type="number" v-model.trim="weight" required="true" autofocus/>
              <label for="vehicle_no">Weight</label>
              </span>
            </div>
          </div>
        </div>
          <template #footer>
            <Button label="Save" @click="save_record" icon="pi pi-check" class="p-button-success" />
          </template>
        </Dialog>


        <Dialog header="Outward Entry" v-model:visible="productDialog" :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }" :modal="true">
          <div class="col-12">
            <div class="card">
              <loading :active="isLoading" :can-cancel="true" color="#173EA3" :is-full-page="fullPagemodel"></loading>
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                    <InputText id="vehicle_no" type="text" v-model.trim="product.vehicle_no" required="true" autofocus :disabled="product._id"
                      :class="{ 'p-invalid': submitted && !product.vehicle_no }" />
                    <label for="vehicle_no">Vehicle Number</label>
                  </span>
                </div>
                <div class="field col-12 md:col-1" style="margin-top: 1%;">
                  <Button label="Search" class="p-button-primary p-button-sm" @click="search_vehicle(1)" />
                </div>
                <!-- <div class="field col-12 md:col-1" style="margin-top: 1%;">
                  <Button label="Reset" class="p-button-danger p-button-sm" @click="reset()" />
                </div> -->
                
                <div class="field col-12 md:col-4" style="margin-top: 1%;" v-if="driver_list1.length > 0">
                  <span class="p-float-label">
                    <Calendar v-model="out_date" dateFormat="dd-mm-yy" :showIcon="true" :showTime="false" hourFormat="12"
                       />
                    <label>Date</label>
                  </span>
                </div>
                <div class="field col-12 md:col-3" style="margin-top: 1%;" v-if="driver_list1.length > 0">
                  <span class="p-float-label">
                    <Calendar id="calendar-timeonly" v-model="out_time" timeOnly hourFormat="12" />
                    <label>Out Time</label>
                  </span>
                </div>
                <div class="field col-12 md:col-1" style="margin-top: 1%;" v-if="driver_list1.length > 0">
                  <Button icon="pi pi-plus" class="p-button-success mr-2" @click="openNew2" />
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%;" v-if="driver_list1.length > 0">
                  <div style="text-align: right;">
              <span>Total: </span>{{ material_type_list.length }}
            </div>
                  <DataTable ref="home_dt" :value="material_type_list" class="p-datatable-sm" :rows="10"
                              responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="sr_no"
                              :rowHover="true" showGridlines>
                              <template #empty> No Record found. </template>
                    <Column field="material_type" header="Material Type" style="min-width: 3rem">
                      <template #body="{ data }">
                        <span>{{ data.material_type }}</span>
                      </template>
                    </Column>
                    <Column field="weight" headerStyle="min-width:5rem;" header="Weight">
                        <template #body="{ data }">
                            <InputText
                                    id="weight"
                                    type="text"
                                    size="10"
                                    v-model.trim="data.weight"
                                    required="true"
                                    autofocus
                                    />
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="min-width:5rem;">
						          <template #body="slotProps">
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-warning mt-2" @click="confirmDelete(slotProps.data)" />
                      </template>
                    </Column>
                  </DataTable>
                </div>
                
                <!-- <div class="field col-12 md:col-12" style="margin-top: 1%;" v-if="driver_list1.length > 0">
                  <div style="color:white; background-color: #173EA3; font-size: 12px; line-height: 0.9"
                    class="card mb-0 grid" v-for="(data1, key) in driver_list1" :key="key">
                    <div style="text-align: right" class="col-12 md:col-12">
                      <span>Status : </span><span v-if="data1.status == 'Active' || data1.status == 'active'">
                        <badge :value="data1.status" severity="success"></badge>
                      </span>
                      <span v-else-if="data1.status == 'InActive' || data1.status == 'In Active'
                        ">
                        <badge :value="data1.status" severity="warning"></badge>
                      </span>
                      <span v-else-if="data1.status == 'Delete' || data1.status == 'Deleted'">
                        <badge :value="data1.status" severity="danger"></badge>
                      </span>
                      <span v-else>-</span>
                      
                    </div>
                    <div style="text-align: left" class="col-12 md:col-12">
                      <h4>Vehicle Details</h4>
                    </div>
                    <div class="col-12 md:col-2">
                      <img style="max-width: 70px; height: 70px; border-radius: 50%" :src="data1.vehicle_photo
                        ? data1.vehicle_photo
                        : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
                        " />
                    </div>
                    <div class="grid col-12 md:col-10">
                      <div class="grid col-12 md:col-6">
                        <div class="col-6 md:col-6">
                          <span>Registration No : </span>
                        </div>
                        <div class="col-6 md:col-6" style="text-align: left">
                          <span style="text-align: right"><b v-if="data1.registration_number">{{ data1.registration_number
                          }}</b> </span>
                        </div>
                      </div>
                      <div class="grid col-12 md:col-6">
                        <div class="col-6 md:col-6">
                          <span>Vehicle Type : </span>
                        </div>
                        <div class="col-6 md:col-6" style="text-align: left">
                          <b>{{ data1.vehicle_type }}</b>
                        </div>
                      </div>
                      <div class="grid col-12 md:col-6">
                        <div class="col-6 md:col-6">
                          <span>RC Number : </span>
                        </div>
                        <div class="col-6 md:col-6" style="text-align: left">
                          <b>{{ data1.rc_number }}</b>
                        </div>
                      </div>
                      <div class="grid col-12 md:col-6">
                        <div class="col-6 md:col-6">
                          <span>PUC Validity : </span>
                        </div>
                        <div class="col-6 md:col-6" style="text-align: left">
                          <b>{{ data1.puc_validity }}</b>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <template #footer>
            <Button label="Save" @click="add_inward" icon="pi pi-check" class="p-button-success" />
           
          </template>
        </Dialog>
        <!-- 
  -----------------------------------------------------------------------------------------------------------   -->
        <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete Event
              <b>{{ product.name }}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteevent" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      waste_type_dropdownItem:null,
      waste_type_dropdownItems:null,
      weight:'',
      add_productDialog:false,
      material_type_list:[],
      
      driver_list1: [],
      state_dropdownItems: [{ name: 'Andhra Pradesh', value: 'Andhra Pradesh' }, { name: 'Arunachal Pradesh', value: 'Arunachal Pradesh' }, { name: 'Assam', value: 'Assam' }, { name: 'Bihar', value: 'Bihar' }, { name: 'Chhattisgarh', value: 'Chhattisgarh' }, { name: 'Goa', value: 'Goa' }, { name: 'Gujarat', value: 'Gujarat' }, { name: 'Haryana', value: 'Haryana' }, { name: 'Himachal Pradesh', value: 'Himachal Pradesh' }, { name: 'Jharkhand', value: 'Jharkhand' }, { name: 'Karnataka', value: 'Karnataka' }, { name: 'Kerala', value: 'Kerala' }, { name: 'Madhya Pradesh', value: 'Madhya Pradesh' }, { name: 'Maharashtra', value: 'Maharashtra' }, { name: 'Manipur', value: 'Manipur' }, { name: 'Meghalaya', value: 'Meghalaya' }, { name: 'Mizoram', value: 'Mizoram' }, { name: 'Nagaland', value: 'Nagaland' }, { name: 'Odisha', value: 'Odisha' }, { name: 'Punjab', value: 'Punjab' }, { name: 'Rajasthan', value: 'Rajasthan' }, { name: 'Sikkim', value: 'Sikkim' }, { name: 'Tamil Nadu', value: 'Tamil Nadu' }, { name: 'Telangana', value: 'Telangana' }, { name: 'Tripura', value: 'Tripura' }, { name: 'Uttar Pradesh', value: 'Uttar Pradesh' }, { name: 'Uttarakhand', value: 'Uttarakhand' }, { name: 'West Bengal', value: 'West Bengal' }],
      state_dropdownItem: { name: "", value: "" },
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      fullPagemodel: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      vehicle_no: "",
      event_from_date: "",
      out_date: "",
      out_time: "",
      event_to_date: "",
      event_status: null,
      event_city: "",
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      edit_productDialog: false,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "Out Garbage",
      "/Out_garbage"
    );
    //let Breadcrum_data = this.BreadcrumbService.menumaster();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
    // this.event_from_date = new Date();
    // this.event_to_date = new Date();
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    await this.get_material_type_master();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    search_vehicle(flag) {
      if (flag==1) 
      {
        this.out_date = new Date();
        this.out_time = new Date();
      } 
      
      this.driver_list1 = [];
      this.product.wet_waste = '';
      this.product.dry_waste = '';
      var data = {
        registration_number: this.product.vehicle_no,
      };
      this.isLoading = true;
      var promise = apis.searchGroupVehicleAdd(data);
      promise
        .then(response => {
          this.isLoading = false;
          this.driver_list1 = response.data.data;
          if (this.driver_list1.length == 0) {
            alert("vehicle Not Found")
          }
        }
        )
    },
    async search(count) {
      if (count == 2) {
        this.vehicle_no = "";
         this.event_from_date = "";
         this.event_to_date = "";
        this.event_status = null;
        this.event_city = "";
      }
      await this.get_list();
      await this.get_count();
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.material_type_list=this.product.material_details;
      if (this.product.date_time) 
      {
        this.out_date = new Date(this.product.date_time);
        this.out_time = new Date(this.product.date_time);
      }
      
      this.search_vehicle(2);
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
        type:'Outward',
        vehicle_no: this.vehicle_no,
        from_date: this.dateFormatYMD(this.event_from_date),
        to_date: this.dateFormatYMD(this.event_to_date),
        city: this.event_city,
        status: this.event_status == null ? '' : this.event_status.value
      };
      this.loading = true;
      var promise = apis.In_Out_Garbage_list(data);
      promise.then((response) => {
        this.loading = false;
        this.totalRecords = response.data.data;
      });
    },
    get_material_type_master: function()
    { this.waste_type_dropdownItems=null;
      var data = {
        type:"Outward"
      };
      var promise = apis.get_material_type_master(data, this.id);
      promise.then((response) => {
        this.waste_type_dropdownItems=response.data.data;
      });
    },
    get_list: function () {
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        type:'Outward',
        vehicle_no: this.vehicle_no,
        from_date: this.dateFormatYMD(this.event_from_date),
        to_date: this.dateFormatYMD(this.event_to_date),
        city: this.event_city,
        status: this.event_status == null ? '' : this.event_status.value
      };
      this.loading = true;
      var promise = apis.In_Out_Garbage_list(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    save_record()
    {   if (!this.waste_type_dropdownItem || this.waste_type_dropdownItem==null || this.waste_type_dropdownItem==undefined) 
      {
        this.$toast.add({ severity: 'error', summary: 'Error!!', detail: 'Please Select Material Type', life: 3000 });
        return false;
      }
      if (!this.weight || this.weight==null || this.weight==undefined) 
      {
        this.$toast.add({ severity: 'error', summary: 'Error!!', detail: 'Please Enter Weight', life: 3000 });
        return false;
      }
      const nameExists = this.material_type_list.some(item => item.material_type === this.waste_type_dropdownItem.name);
      if (!nameExists) 
      {
        this.material_type_list.push({material_type:this.waste_type_dropdownItem.name,weight : this.weight});
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Material Added', life: 3000 });
      }
      if (nameExists) 
      {
        this.$toast.add({ severity: 'error', summary: 'Error!!', detail: 'Material already Present in list', life: 3000 });
        return false;
      }
      
      this.weight='';
      this.waste_type_dropdownItem=null;
      this.add_productDialog = false;
    },
    openNew2()
    {
      this.add_productDialog = true;
      this.weight='';
      this.waste_type_dropdownItem=null;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.material_type_list=[];
      this.selectstatus = null;
      this.state_dropdownItem = null;
      this.driver_list1 = [];
      this.out_date = new Date();
      this.out_time = new Date();
      this.product.wet_waste = '';
      this.product.dry_waste = '';
     
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    date_time(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;
        }
        else {
          let hours = inputDate.getHours();
          let minutes = ("0" + inputDate.getMinutes()).slice(-2);
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12; // Handle midnight (0:00) as 12 AM
          return hours + ":" + minutes + " " + ampm;
        }
      }
      else {
        return "";
      }
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;
        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return date + "-" + month + "-" + year;
          }
        }
      }
      else {
        return "";
      }
    },
    dateFormatYMD(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == 'NaN-NaN-NaN') {
          return postdate;
        }
        else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == 'aN') {
            return postdate;
          }
          else {
            return year + "-" + month + "-" + date;
          }
        }
      }
      else {
        return "";
      }
    },
    async add_inward() {
      this.submitted = true;
      if (this.material_type_list.length==0) 
      {
        this.$toast.add({ severity: 'error', summary: 'Error!!', detail: 'Please Add Atlest One Material Entry', life: 3000 });
        return false;
      }
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          vehicle_no: this.product.vehicle_no,
          date_time : this.dateFormatYMD(this.out_date)+" "+this.date_time(this.out_time),
          type:'Outward',
          material_details:this.material_type_list,
          updated_by: localStorage.getItem('id'),
          "client_id": localStorage.getItem("client_id"),
        };
        this.isLoadingModel = true;
        var promise = apis.edit_In_out_Garbage(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      else {
        var data2 = {
          vehicle_no: this.product.vehicle_no,
          date_time : this.dateFormatYMD(this.out_date)+" "+this.date_time(this.out_time),
          type:'Outward',
          material_details:this.material_type_list,
          created_by: localStorage.getItem('id'),
          "client_id": localStorage.getItem("client_id"),
          
        };
        this.isLoadingModel = true;
        var promise2 = apis.add_In_Out_Garbage(data2);
        promise2
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    confirmDelete(data)
    {
      this.material_type_list = this.material_type_list.filter(val => val.material_type !== data.material_type);
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem('id')
        };
        this.isLoadingModel = true;
        var promise = apis.deleteevent(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";

.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  